export function initTestimonials() {
  const frameList = document.querySelectorAll('[data-testimonials-embed]');

  if (!frameList.length) {
    return;
  }

  frameList.forEach((frame) => {
    frame.src = resolveSrc(frame);

    if (!window.iFrameResize) {
      return;
    }

    window.iFrameResize({ log: false, checkOrigin: false }, `#${frame.id}`);
  });
}

function resolveSrc(frame) {
  const mobileSrc = frame.dataset.srcMobile;
  const mediaQuery = frame.dataset.mediaQuery;

  if (!mobileSrc || !mediaQuery) {
    return frame.dataset.srcDesktop;
  }

  return window.matchMedia(mediaQuery).matches ? mobileSrc : frame.dataset.srcDesktop;
}
